/* Felmiro — interacción de las secciones felmi-* (header, reveal, producto destacado, catálogo).
   Se carga una sola vez desde layout/theme.liquid. */
(() => {
  if (window.__felmiTienda) return;
  window.__felmiTienda = true;
  document.documentElement.classList.add('fm-js');

  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  const initReveal = (root = document) => {
    const els = root.querySelectorAll('.fm-reveal:not(.is-in)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Diálogos (menú y buscador) ---------- */
  const abrirDialogo = (dlg, disparador) => {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    disparador?.setAttribute('aria-expanded', 'true');
    dlg._disparador = disparador;
    requestAnimationFrame(() => dlg.classList.add('is-abierto'));
    const foco = dlg.querySelector('[data-fm-foco]');
    if (foco) setTimeout(() => foco.focus(), 60);
  };
  const cerrarDialogo = (dlg) => {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-abierto');
    dlg._disparador?.setAttribute('aria-expanded', 'false');
    const fin = () => {
      if (dlg.open) dlg.close();
      dlg._disparador?.focus();
    };
    if (reducido) fin();
    else setTimeout(fin, 240);
  };

  const initHeader = (root) => {
    if (!root || root.dataset.fmListo) return;
    root.dataset.fmListo = 'true';

    /* La barra de anuncios se mueve sola con CSS (marquee), ver .fm-anuncio__track. */

    root.querySelectorAll('[data-fm-abrir]').forEach((btn) => {
      const dlg = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', () => abrirDialogo(dlg, btn));
    });
    root.querySelectorAll('dialog.fm-menu, dialog.fm-busca').forEach((dlg) => {
      dlg.addEventListener('cancel', (e) => {
        e.preventDefault();
        cerrarDialogo(dlg);
      });
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg) cerrarDialogo(dlg);
      });
      dlg.querySelectorAll('[data-fm-cerrar]').forEach((b) => b.addEventListener('click', () => cerrarDialogo(dlg)));
      dlg.querySelectorAll('a[href]').forEach((a) => a.addEventListener('click', () => cerrarDialogo(dlg)));
    });

    const hd = root.querySelector('.fm-hd');
    if (hd) {
      const pintar = () => hd.classList.toggle('is-scrolled', window.scrollY > 8);
      window.addEventListener('scroll', pintar, { passive: true });
      pintar();
    }
  };

  /* ---------- Producto destacado (home) ---------- */
  const initDestacado = (root) => {
    if (!root || root.dataset.fmListo) return;
    root.dataset.fmListo = 'true';
    const datosEl = root.querySelector('[data-fm-variantes]');
    if (!datosEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    const idInput = root.querySelector('input[name="id"]');
    const btn = root.querySelector('[data-fm-agregar]');
    const btnTexto = btn?.querySelector('[data-fm-agregar-texto]');
    const precio = root.querySelector('[data-fm-precio]');
    const tachado = root.querySelector('[data-fm-tachado]');
    const ahorro = root.querySelector('[data-fm-ahorro]');
    const principal = root.querySelector('.fm-pd__principal img');
    const minis = root.querySelectorAll('[data-fm-mini]');
    const etiquetas = root.querySelectorAll('[data-fm-elegido]');
    const formato = root.dataset.moneda || '';
    const textos = {
      agregar: btn?.dataset.textoAgregar || 'Agregar al carrito',
      agotado: btn?.dataset.textoAgotado || 'Sin stock',
    };
    const dinero = (cents) => {
      const conSep = (n, dec, miles, decSep) => {
        const [ent, frac] = (n / 100).toFixed(dec).split('.');
        return ent.replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (frac ? decSep + frac : '');
      };
      const m = formato.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!m) return conSep(cents, 2, ',', '.');
      const valor = {
        amount: conSep(cents, 2, ',', '.'),
        amount_no_decimals: conSep(cents, 0, ',', '.'),
        amount_with_comma_separator: conSep(cents, 2, '.', ','),
        amount_no_decimals_with_comma_separator: conSep(cents, 0, '.', ','),
        amount_with_apostrophe_separator: conSep(cents, 2, "'", '.'),
      }[m[1]] ?? conSep(cents, 2, ',', '.');
      return formato.replace(m[0], valor);
    };

    const mostrarMedia = (mediaId) => {
      if (!mediaId || !principal) return;
      const mini = root.querySelector(`[data-fm-mini][data-media-id="${mediaId}"]`);
      if (!mini) return;
      principal.src = mini.dataset.src;
      principal.srcset = mini.dataset.srcset || '';
      principal.alt = mini.dataset.alt || '';
      minis.forEach((m) => m.setAttribute('aria-current', String(m === mini)));
    };
    minis.forEach((m) => m.addEventListener('click', () => mostrarMedia(m.dataset.mediaId)));

    const actualizar = () => {
      const elegidas = [...root.querySelectorAll('[data-fm-opcion]')].map((fs) => fs.querySelector('input:checked')?.value);
      const v = variantes.find((x) => x.options.every((o, i) => o === elegidas[i]));
      etiquetas.forEach((el, i) => (el.textContent = elegidas[i] || ''));
      if (!v) {
        if (btn) {
          btn.disabled = true;
          if (btnTexto) btnTexto.textContent = textos.agotado;
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (precio) precio.textContent = dinero(v.price);
      const hayTachado = v.compare_at_price && v.compare_at_price > v.price;
      if (tachado) {
        tachado.hidden = !hayTachado;
        if (hayTachado) tachado.textContent = dinero(v.compare_at_price);
      }
      if (ahorro) {
        ahorro.hidden = !hayTachado;
        if (hayTachado) ahorro.textContent = (ahorro.dataset.plantilla || '-[p]%').replace('[p]', Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price));
      }
      if (btn) {
        btn.disabled = !v.available;
        if (btnTexto) btnTexto.textContent = v.available ? textos.agregar : textos.agotado;
      }
      if (v.media_id) mostrarMedia(String(v.media_id));
    };
    root.querySelectorAll('[data-fm-opcion] input').forEach((inp) => inp.addEventListener('change', actualizar));
  };

  /* ---------- Catálogo: orden ---------- */
  const initOrden = (root = document) => {
    root.querySelectorAll('[data-fm-orden]').forEach((sel) => {
      if (sel.dataset.fmListo) return;
      sel.dataset.fmListo = 'true';
      sel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  };

  /* ---------- Opiniones (Judge.me) ----------
     La sección trae las primeras opiniones del metafield de Judge.me. Acá se piden las 85
     a la misma API pública que usa su widget y se dibujan con el diseño de la tienda:
     sin fechas, sin insignias y sin el nombre del producto que el importador dejó como
     texto en las opiniones que no tenían comentario. No se agrega ni se cambia nada. */
  const escaparHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const textoPlano = (html) => {
    const d = document.createElement('div');
    d.innerHTML = String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p[^>]*>/gi, '\n');
    return (d.textContent || '')
      .split('\n')
      .map((l) => l.trim())
      .filter(Boolean)
      .join('\n');
  };
  const ESTRELLA = '<path d="M12 2.8l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 16.8l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/>';
  const estrellasHtml = (nota) => {
    let s = '<span class="fm-stars" style="--st: 15px;" aria-hidden="true">';
    for (let n = 1; n <= 5; n++) s += `<svg viewBox="0 0 24 24"${nota < n - 0.5 ? ' class="is-off"' : ''}>${ESTRELLA}</svg>`;
    return s + '</span>';
  };

  const initResenas = (wrap) => {
    if (wrap.dataset.fmListo) return;
    wrap.dataset.fmListo = 'true';
    const lista = wrap.querySelector('.fm-res__lista');
    const boton = wrap.querySelector('[data-fm-resenas-mas]');
    const botonTxt = wrap.querySelector('[data-fm-resenas-mas-txt]');
    const seccion = wrap.closest('section');
    const visor = seccion && seccion.querySelector('[data-fm-resenas-visor]');
    const titulo = wrap.dataset.productoTitulo || '';
    const ini = parseInt(wrap.dataset.iniciales, 10) || 6;
    const iniMovil = parseInt(wrap.dataset.inicialesMovil, 10) || 4;
    const textoVerTodas = botonTxt ? botonTxt.textContent : '';
    let abierto = false;
    let fotosPorResena = [];

    const pintar = (resenas) => {
      fotosPorResena = [];
      lista.innerHTML = resenas
        .map((r, i) => {
          const pos = i + 1;
          const nombre = textoPlano(r.reviewer_name);
          let texto = textoPlano(r.body_html);
          if (texto === titulo) texto = '';
          const fotos = (r.pictures_urls || []).map((f) => f.original || f.huge || f.compact).filter(Boolean);
          fotosPorResena.push(fotos);
          const visibles = fotos.slice(0, 3);
          const resto = fotos.length - visibles.length;
          const fotosHtml = visibles.length
            ? `<div class="fm-rev__fotos">${visibles
                .map(
                  (u, k) =>
                    `<button type="button" class="fm-rev__foto" data-fm-foto="${i}:${k}" aria-label="Ver foto ${k + 1} de ${fotos.length}">` +
                    `<img src="${escaparHtml(u)}" alt="Foto de la opinión de ${escaparHtml(nombre)}" loading="lazy" width="96" height="96">` +
                    (k === 2 && resto > 0 ? `<span class="fm-rev__foto-mas">+${resto}</span>` : '') +
                    '</button>'
                )
                .join('')}</div>`
            : '';
          const clases = ['fm-rev'];
          if (pos > ini) clases.push('is-extra');
          if (pos > iniMovil) clases.push('is-extra-movil');
          return (
            `<li class="${clases.join(' ')}">` +
            `<div class="fm-rev__cab">${estrellasHtml(r.rating)}<span class="visually-hidden">${r.rating} de 5 estrellas</span>` +
            `<p class="fm-rev__autor">${escaparHtml(nombre)}</p></div>` +
            (texto ? `<p class="fm-rev__texto">${escaparHtml(texto).replace(/\n/g, '<br>')}</p>` : '') +
            fotosHtml +
            '</li>'
          );
        })
        .join('');
      wrap.classList.toggle('is-abierto', abierto);
    };

    /* Orden: el "Mayor puntuación" que ofrece el propio Judge.me y, dentro de cada
       puntuación, primero las que tienen comentario (más largo primero). Todas las
       opiniones se muestran igual con el botón; el promedio no cambia. */
    const ordenar = (resenas) =>
      resenas
        .map((r, i) => {
          let t = textoPlano(r.body_html);
          if (t === titulo) t = '';
          return { r, i, largo: t.length };
        })
        .sort((a, b) => b.r.rating - a.r.rating || b.largo - a.largo || a.i - b.i)
        .map((x) => x.r);

    /* Textos largos: 5 líneas y "Leer más", para que una sola opinión no ocupe la pantalla. */
    const recortar = () => {
      lista.querySelectorAll('.fm-rev__texto:not([data-medido])').forEach((p) => {
        if (!p.offsetParent) return;
        p.dataset.medido = 'true';
        if (p.scrollHeight > p.clientHeight + 2) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'fm-rev__leer';
          b.textContent = 'Leer más';
          b.setAttribute('aria-expanded', 'false');
          p.after(b);
        }
      });
    };
    lista.addEventListener('click', (e) => {
      const b = e.target.closest('.fm-rev__leer');
      if (!b) return;
      const p = b.previousElementSibling;
      const abre = !p.classList.contains('is-completo');
      p.classList.toggle('is-completo', abre);
      b.textContent = abre ? 'Leer menos' : 'Leer más';
      b.setAttribute('aria-expanded', String(abre));
    });

    const base =
      'https://cdn.judge.me/reviews/reviews_for_widget?product_id=' + encodeURIComponent(wrap.dataset.productoId) +
      '&shop_domain=' + encodeURIComponent(wrap.dataset.tienda) +
      '&platform=shopify&per_page=30&sort_by=created_at&sort_dir=desc';
    const pedir = (pag) => fetch(`${base}&page=${pag}`, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : Promise.reject(r.status)));

    const cargar = pedir(1)
      .then((d) => {
        const paginas = (d.pagination && d.pagination.total_pages) || 1;
        const resto = [];
        for (let p = 2; p <= Math.min(paginas, 10); p++) resto.push(pedir(p));
        return Promise.all(resto).then((ds) => [d, ...ds].flatMap((x) => x.reviews || []));
      })
      .then((todas) => {
        const vistas = new Set();
        const unicas = todas.filter((r) => (vistas.has(r.uuid) ? false : vistas.add(r.uuid)));
        if (unicas.length) pintar(ordenar(unicas));
        recortar();
        return unicas.length;
      })
      .catch(() => 0);

    if (boton) {
      boton.addEventListener('click', () => {
        abierto = !abierto;
        boton.setAttribute('aria-expanded', String(abierto));
        if (abierto) {
          boton.classList.add('is-cargando');
          cargar.then(() => {
            boton.classList.remove('is-cargando');
            if (!abierto) return;
            wrap.classList.add('is-abierto');
            botonTxt.textContent = 'Ver menos opiniones';
            recortar();
          });
        } else {
          wrap.classList.remove('is-abierto');
          botonTxt.textContent = textoVerTodas;
          const y = seccion.getBoundingClientRect().top + window.scrollY - 80;
          if (window.scrollY > y) window.scrollTo({ top: y, behavior: reducido ? 'auto' : 'smooth' });
        }
      });
    }

    if (visor) {
      const img = visor.querySelector('[data-fm-visor-img]');
      const prev = visor.querySelector('[data-fm-visor-prev]');
      const next = visor.querySelector('[data-fm-visor-next]');
      let actual = [];
      let idx = 0;
      const mostrar = () => {
        img.src = actual[idx];
        img.alt = `Foto ${idx + 1} de ${actual.length} de la opinión`;
        prev.hidden = next.hidden = actual.length < 2;
      };
      lista.addEventListener('click', (e) => {
        const b = e.target.closest('[data-fm-foto]');
        if (!b) return;
        const [ri, fi] = b.dataset.fmFoto.split(':').map(Number);
        actual = fotosPorResena[ri] || [];
        if (!actual.length || typeof visor.showModal !== 'function') return;
        idx = fi;
        mostrar();
        visor.showModal();
      });
      prev.addEventListener('click', () => { idx = (idx - 1 + actual.length) % actual.length; mostrar(); });
      next.addEventListener('click', () => { idx = (idx + 1) % actual.length; mostrar(); });
      visor.querySelector('[data-fm-visor-cerrar]').addEventListener('click', () => visor.close());
      visor.addEventListener('click', (e) => { if (e.target === visor) visor.close(); });
      visor.addEventListener('close', () => { img.removeAttribute('src'); });
    }
  };

  const initTodo = (root = document) => {
    root.querySelectorAll('[data-fm-resenas]').forEach(initResenas);
    root.querySelectorAll('[data-fm-header]').forEach(initHeader);
    root.querySelectorAll('[data-fm-destacado]').forEach(initDestacado);
    initOrden(root);
    initReveal(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initTodo(), { once: true });
  else initTodo();

  document.addEventListener('shopify:section:load', (e) => initTodo(e.target));
})();
